<template>
  <div>
     <div class="row">
        <div class="col-12 mb-2" v-for="(item, index) in strings" :key="index">
          <div class="mb-2">{{label}} {{index + 1}}</div>
          <div class="form-inline">
            <div class="form-group position-relative" @click="getIndex(index)" data-toggle="modal" data-target="#map_modal">
              <!-- @input="fireInput" data-toggle="title" -->
              <input :title="item.address" v-model="item.address"  :type="type || 'text' " class="form-control"/>
              <!-- @click="getIndex(index)" data-toggle="modal" data-target="#map_modal" -->
              <div v-if="mapIcon"  class="map-icon position-absolute">
                  <i class="fas fa-map-marker-alt"></i>
              </div>
            </div>
            <div class="form-group d-flex justify-content-center">
              <div @click="removeOne(index)" class="close-icon">
                  <i class="fad fa-times-circle"></i>
              </div>
            </div>
          </div>
       </div>
       <div class="col-12 mt-3">
          <button :disabled="strings.length == max" v-on:click="addOne" class="btn p-3 btn-block border-dotted text-black text-uppercase font-weight-bold">{{$t('providers.step6_add')}}</button>
       </div>
        <Modal ref="mapModal" id="map_modal">
          <template v-slot:modal-header >
              <div class="modal-header">
                <h5 class="modal-title">{{$t('providers.step6_choose_location')}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
          </template>
          <template v-slot:modal-body>
              <div class="modal-body">
                <input ref="searchInput" v-bind:placeholder="$t('providers.step6_input_location')" type="text" class="form-control mb-2" />
                <div ref="mapCanvas" id="map-canvas"></div>
                <div ref="mapErrorMsg"></div>
                <span class="text-size pt-2 pb-2">{{$t('providers.step6_drag_map')}}</span>
                <button data-dismiss="modal" @click="applyLocation()" type="button" class="btn btn-primary btn-block text-light">OK</button>
              </div>
          </template>
       </Modal>
       <!-- <div class="modal fade" id="map_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Choose your location</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                  <input ref="searchInput" placeholder="Enter registered website" type="text" class="form-control mb-2" />
                  <div ref="mapCanvas" id="map-canvas"></div>
                  <p>Drag the pin to select your location on the map</p>
                  <button type="button" class="btn btn-primary btn-block">OK</button>
              </div>
            </div>
          </div>
      </div> -->
     </div>
  </div>
</template>
<style lang="scss">
  .modal{
      z-index: 20;  
      &-backdrop{
        z-index: 10 !important;   
      }
  }

  .pac-container {
      background-color: #FFF;
      z-index: 20;
      // position: fixed;
      // display: inline-block;
      margin-top: 4px;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      font-size: 14px;
      line-height: 19px;
  }
  .pac-item {
    font-size: 14px;
    padding: 5px;
     display: block;
  }
  .pac-item-query {
    font-size:14px;
    display: block;
  }

  .pac-icon{
    display: none;
  }

</style>
<style scoped lang="scss">
.border-dotted{
  border: 1px dotted #C0C0C0;
}
.form-inline{
  .form-group{
    input{
      width: 100%;
    }
    .map-icon{
      width: 32px;
      height: 31px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      background: var(--primary);
      align-items: center;
      top: 6px;
      right: 12px;
      i{
        font-size: 15px;
        &:hover{
          // cursor: pointer;
        }
      }
    }
    .close-icon{
      i{ 
        font-size: 25px;
        &:hover{
          cursor: pointer;
        }
        &::before{
           color: white;
        }
      }
    }
  }
  .form-group:nth-child(1){
    width: 90%;
  }
  .form-group:nth-child(2){
    width: 10%;
  }
}
   #map-canvas{
     height: 100%;
     min-height: 400px;
     width: initial;
   }
</style>

<script>
import Modal from "./Modal.vue";
export default {
  components:{
    Modal
  },
  props: {
    value: Array,
    label: String,
    type: String,
    max: {
       type: Number,
       default: 3
    },
    mapIcon:{
       type: Boolean,
       default: false
    }
  },
  watch:{
     value: function() {   
        let value = this.value || [];
        this.strings = value.map(item => {
            return item;
        });
     }
  },
  data(){
    let value = this.value || [];
    return {
      strings: value.map((item) => {
          return item;
      }),
      index: '',
      location:{
        point:{
          type: '',
          coordinates: []
        },
        address:'',
        city:'',
        district:'',
        ward:'',
        street:'',
        houseNumber:'',
        postalCode: '',
        location:{},
        name:'',
        provider:'',
        user:'',
      }
    };
  },
  methods: {
      resetFields(){
        this.location = {
          point:{
            type: '',
            coordinates: []
          },
          address:'',
          city:'',
          district:'',
          ward:'',
          street:'',
          houseNumber:'',
          postalCode: '',
          location:{},
          name:'',
          provider:'',
          user:'',
        }
     },
     getIndex(index) {
        this.index = index;
        this.$forceUpdate();

        console.log("index", index);
        if(this.strings[index].address){

          this.$refs.searchInput.value = this.strings[index].address;

          var location = this.strings[index].location;
          console.log("this", this.strings[index]);

          this.getGeocodePosition(location);

          window.marker.setPosition(location);
          window.map.setCenter(location);
          window.map.setZoom(15);

        }else{
            console.log("vào đây đi chứ");
            this.$refs.searchInput.value = "";
            this.getLocationOnBrowser(window.map, window.marker);
            this.getGeocodePosition(window.marker.getPosition());
        }

     },
     applyLocation(){
        this.resetFields();
        if(window.self.place){
          this.location.address = window.self.place.formatted_address;
          this.location.name = window.self.place.name;
          window.self.place.address_components.forEach((item,index)=>{
              if(item.types[0] === 'street_number'){
                  this.location.houseNumber =  window.self.place.address_components[index].long_name;
              }

              if(item.types[0] === 'administrative_area_level_1'){
                  this.location.city = window.self.place.address_components[index].long_name;
                  this.location.state = window.self.place.address_components[index].long_name;
              }

              if(item.types[0] === 'administrative_area_level_2'){
                this.location.district = window.self.place.address_components[index].long_name;
              }

              if(item.types[0] === 'postal_code'){
                  this.location.postalCode = window.self.place.address_components[index].long_name;
              }

              if(item.types[0] === 'route'){
                  this.location.street = window.self.place.address_components[index].long_name;
              }
          })
          // if(window.self.place.geometry.viewport.Ua){
          //   this.location.point.coordinates.push(window.self.place.geometry.viewport.Ua.i);
          // }
          // if(window.self.place.geometry.viewport.Ya){
          //   this.location.point.coordinates.push(window.self.place.geometry.viewport.Ya.i);
          // }
          if(window.self.place.geometry.location){
            this.location.point.coordinates.push(window.self.place.geometry.location.lng());
          }
          if(window.self.place.geometry.location){
            this.location.point.coordinates.push(window.self.place.geometry.location.lat());
          }
          if(window.self.place.geometry.location){
              this.location.location = window.self.place.geometry.location;
          }
          this.location.point.type = "Point";
          this.strings[this.index] = this.location;
        }
        this.strings[this.index] = this.location;
        console.log("this", this.location);
        this.fireInput(); 
        this.$forceUpdate();
     },
     addOne() {
        this.resetFields();
        if(this.strings.length < this.max){
          this.strings.push(this.location);
          this.fireInput();
        }
     },
     removeOne(index){
        this.strings.splice(index, 1);
        this.fireInput();
     },
     fireInput() {
        var value = this.strings.map((item) => {
            return item;
        });
        this.$emit('input', value);
     },
     getGeocodePosition(pos){
         console.log("position", pos);
         var geocoder = new window.google.maps.Geocoder();
         geocoder.geocode({ latLng: pos }, (results, status) =>{
              if (status == window.google.maps.GeocoderStatus.OK) 
              {
                  console.log("result", results);
                  window.self.place = results[0];
                  this.$refs.searchInput.value = results[0].formatted_address;
                  // this.$refs.mapErrorMsg.hide(100);
              } 
              else 
              {
                  this.$refs.mapErrorMsg.html('Cannot determine address at this location.'+ status).show(100);
              }
          }
        );
     },
     getLocationOnBrowser(map, marker){
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position){
               console.log("vaoo", position.coords.latitude + "  " + position.coords.longitude);
               console.log("vaoo position", position);
                // var pos = {
                //   lat: position.coords.latitude,
                //   lng: position.coords.longitude
                // };
                var pos = new window.google.maps.LatLng(position.coords.latitude,position.coords.longitude);
                marker.setPosition(pos);
                map.setCenter(pos);
                map.setZoom(15);
            });
        }else{
           alert('Geolocation not detected');   
        }
     },
     placeAutocomplete(map, marker){
        var autocomplete = new window.google.maps.places.Autocomplete(this.$refs.searchInput, {
            types: []
        });
        // autocomplete.bindTo('bounds', map);
        autocomplete.setFields(
            ['address_components','plus_code','formatted_address','international_phone_number','geometry', 'name']);

        autocomplete.addListener('place_changed', function(){
            marker.setVisible(false);
            var place = autocomplete.getPlace();
            window.self.place = place;
            console.log("place", place);
            console.log("vaoo nek",autocomplete.getFields());
            if (!place.geometry) {
                window.alert("No details available for input: '" + place.name + "'");
                return;
            }
            if (place.geometry.viewport) 
            {
                map.fitBounds(place.geometry.viewport);
            } else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);  // Why 17? Because it looks good.
            }
            marker.setPosition(place.geometry.location);
            marker.setVisible(true);
        });
     },
     initMap(){

        window.map = new window.google.maps.Map(this.$refs.mapCanvas, {
            center: { lat: 15.6073381, lng: 96.8695771},
            scrollwheel: false,
            zoom: 4
        });

        window.marker = new window.google.maps.Marker({
            map: window.map,
            anchorPoint: new window.google.maps.Point(0, -29),
            animation: window.google.maps.Animation.DROP,
        });  

        this.getLocationOnBrowser(window.map, window.marker);

        window.marker.addListener('dragend', () => {
             window.map.setCenter(window.map.getPosition()); 
            this.getGeocodePosition( window.marker.getPosition());
        });

        window.map.addListener('drag', () => {
               window.marker.setPosition(window.map.getCenter()); 
          });

        window.map.addListener('dragend', () => {
            window.marker.setPosition(window.map.getCenter()); 
            this.getGeocodePosition(window.marker.getPosition());
        });

        this.placeAutocomplete(window.map, window.marker);

     }
  },
  async mounted() {
      this.initMap();
  }
}
</script>